// import styles from "./styles.module.css";

import type { ReactNode } from "react";
import { Trans } from "@lingui/macro";

import CheckIcon from "@kavval/ui/Icons/CheckIcon";

import { InfoBlock } from "@booking/components";

const SellingPoints = ({ items }: { items?: string[] }) => (
  <InfoBlock title={<Trans id="generic.kavvalSellingPoints.title">Les avantages Finishers</Trans>}>
    {items?.map((item) => (
      <div key={item} className="my-2 flex flex-row items-center">
        <CheckIcon className="mr-2 shrink-0" /> <p>{item}</p>
      </div>
    ))}
  </InfoBlock>
);

type ShoppingCartLayoutProps = {
  rightContent?: ReactNode;
  sellingPoints?: string[];
  children: ReactNode;
};

const ShoppingCartLayout = ({ rightContent, sellingPoints, children }: ShoppingCartLayoutProps) => {
  const showSellingPoints = sellingPoints && sellingPoints.length > 0;

  return (
    <div className="md:flex md:flex-row-reverse">
      <div className="md:w-4/12 md:max-w-[400px] shrink-0 -mx-4 sm:-mx-8 md:mr-0 md:ml-10">
        <div className="md:sticky top-10">
          {rightContent}
          {showSellingPoints && (
            <div className="hidden md:block mt-10">
              <SellingPoints items={sellingPoints} />
            </div>
          )}
        </div>
      </div>

      <div className="grow pb-0 md:pb-10">
        {children}
        {showSellingPoints && (
          <div className="md:hidden pt-10">
            <SellingPoints items={sellingPoints} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ShoppingCartLayout;
